export const pains = [
  'Evitás mostrar tu cuerpo porque sentís vergüenza',
  'Te comparás constantemente con otros',
  'Postergás tu vida esperando cambios que no llegan',
  'Te sentís condicionado/a por la mirada ajena',
  'Sentís que te estás perdiendo tu propia vida',
]

export const benefits = [
  'Dejar de postergar tu vida por tu apariencia',
  'Tomar decisiones sobre tu cuerpo desde la libertad, no desde el miedo',
  'Recuperar la confianza para relacionarte sin vergüenza',
  'Vivir el presente sin esperar una "versión futura de ti"',
  'Reconciliarte con los cambios de tu cuerpo',
]

export type Testimonial = {
  name: string
  location: string
  /** Dolor de la sección "¿Reconocés alguna de estas historias?" que traía. */
  pain: string
  /** Beneficio de la sección "Después de 7 días" que consiguió. */
  benefit: string
  text: string
  date: string
}

export const featuredTestimonials: Testimonial[] = [
  {
    name: 'Lucia S.',
    location: 'Buenos Aires, Argentina 🇦🇷',
    pain: 'Evitaba mostrar su cuerpo por vergüenza',
    benefit: 'Recuperó la confianza para relacionarse sin vergüenza',
    text: 'Cinco veranos inventando excusas para no ir a la playa. No cambió mi cuerpo: cambió mi relación con él. El fin de semana fui, sola y sin esconderme.',
    date: '15 de agosto, 2026',
  },
  {
    name: 'Martina F.',
    location: 'Montevideo, Uruguay 🇺🇾',
    pain: 'Postergaba su vida esperando cambios que no llegaban',
    benefit: 'Dejó de postergar su vida por su apariencia',
    text: 'Le decía a mi hija que no a la pileta hasta que me preguntó por qué mi vida tenía que esperar. Estaba perdiendo momentos por una creencia. Hoy voy.',
    date: '10 de agosto, 2026',
  },
  {
    name: 'Carolina G.',
    location: 'Madrid, España 🇪🇸',
    pain: 'Se comparaba constantemente con otros',
    benefit: 'Vive el presente sin esperar una “versión futura”',
    text: 'Soy psicóloga y lo compré por curiosidad. No habla de dietas: habla de la prisión mental. Dejé de medirme contra las demás y se lo recomiendo a mis pacientes.',
    date: '5 de agosto, 2026',
  },
  {
    name: 'Javier S.',
    location: 'Ciudad de México, México 🇲🇽',
    pain: 'Sentía que se estaba perdiendo su propia vida',
    benefit: 'Recuperó la confianza para relacionarse sin vergüenza',
    text: 'Años sin ir a la piscina con mis amigos. Entendí que la vergüenza era una creencia aprendida, no un problema mío. Hoy fui. Fue liberador.',
    date: '28 de julio, 2026',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    name: 'Paula R.',
    location: 'Rosario, Argentina 🇦🇷',
    pain: 'Evitaba mostrar su cuerpo por vergüenza',
    benefit: 'Vive el presente sin esperar una “versión futura”',
    text: 'Tenía 40 fotos guardadas que nunca publiqué. Entendí que no me cuidaba, me escondía. Ahora las comparto.',
    date: '22 de agosto, 2026',
  },
  {
    name: 'Tomás A.',
    location: 'Santiago, Chile 🇨🇱',
    pain: 'Se comparaba constantemente con otros',
    benefit: 'Decide sobre su cuerpo desde la libertad, no desde el miedo',
    text: 'Entrenaba seis veces por semana y nunca era suficiente. Sigo entrenando, pero ahora descanso sin culpa.',
    date: '19 de agosto, 2026',
  },
  {
    name: 'Verónica M.',
    location: 'Córdoba, Argentina 🇦🇷',
    pain: 'Evitaba mostrar su cuerpo por vergüenza',
    benefit: 'Se reconcilió con los cambios de su cuerpo',
    text: 'Después del embarazo evitaba espejos y fotos con mi bebé. Hoy tenemos fotos juntos y las mira encantada.',
    date: '14 de agosto, 2026',
  },
  {
    name: 'Daniela P.',
    location: 'Lima, Perú 🇵🇪',
    pain: 'Se sentía condicionada por la mirada ajena',
    benefit: 'Decide sobre su cuerpo desde la libertad, no desde el miedo',
    text: 'Tengo 52 y creía que después de cierta edad hay que desaparecer. Me compré el vestido rojo y lo uso.',
    date: '8 de agosto, 2026',
  },
  {
    name: 'Federico L.',
    location: 'Bogotá, Colombia 🇨🇴',
    pain: 'Se sentía condicionado por la mirada ajena',
    benefit: 'Se reconcilió con los cambios de su cuerpo',
    text: 'Pensaba que ese juez interno era mi criterio. Era de otros. Distinguirlo cambió cómo me hablo cada día.',
    date: '3 de agosto, 2026',
  },
  {
    name: 'Sofía B.',
    location: 'Asunción, Paraguay 🇵🇾',
    pain: 'Sentía que se estaba perdiendo su propia vida',
    benefit: 'Dejó de postergar su vida por su apariencia',
    text: 'El año pasado cancelé tres citas por cómo me sentía. Fui a una sin cambiarme cuatro veces y estuve presente.',
    date: '30 de julio, 2026',
  },
]

export const faqs = [
  {
    question:
      '¿Tengo que estar dispuesta/o a amar mi cuerpo para leer este libro?',
    answer:
      'No. Y justamente ahí empieza la diferencia. LIBRES DE SER no pretende convencerte de que tenés que amar cada parte de tu cuerpo. Te propone algo más real: dejar de creer que necesitás cambiarlo para sentir que merecés vivir plenamente.',
  },
  {
    question:
      '¿Este libro me va a decir que tengo que dejar de hacer dieta, maquillarme o querer verme mejor?',
    answer:
      'Tampoco. Podés maquillarte, entrenar, hacer dieta, vestirte como quieras o incluso decidir modificar alguna parte de tu cuerpo. La pregunta importante es otra: ¿lo estás haciendo porque realmente lo elegís o porque sentís que necesitás hacerlo para ser aceptado/a?',
  },
  {
    question: '¿Es solamente para mujeres?',
    answer:
      'No. Los estándares de belleza también afectan profundamente a los hombres. Músculos, peso, edad, cabello, altura, apariencia y la presión de demostrar una determinada imagen también pueden convertirse en una prisión. LIBRES DE SER habla de personas, no de un género.',
  },
  {
    question: '¿Qué voy a conseguir realmente leyendo el ebook?',
    answer:
      'No te vamos a prometer que vas a despertar mañana amando tu cuerpo. La transformación es más profunda: vas a comenzar a identificar las creencias que aprendiste sobre cómo "deberías" verte y cuestionar cuánto están condicionando tu manera de vestirte, relacionarte, mostrarte y vivir.',
  },
  {
    question:
      '¿Necesito tener problemas graves con mi cuerpo para que este libro sea para mí?',
    answer:
      'No. Tal vez simplemente evitás determinadas fotos, elegís cierta ropa para esconderte, te comparás demasiado o pensás "cuando me vea mejor, voy a hacerlo". Si alguna vez sentiste que tu vida estaba esperando que tu cuerpo cambiara, este libro puede hablarte directamente.',
  },
  {
    question: '¿Cómo recibo el libro después de comprarlo?',
    answer:
      'Es 100% digital. Una vez confirmado tu pago, recibirás el acceso al ebook directamente en el correo electrónico utilizado durante la compra. No necesitás esperar envíos, paquetes ni repartidores: comprás y recibís el contenido directamente en tu correo.',
  },
]

export const PRICE = {
  original: '$29.90',
  current: '$14.90',
  discount: '50% OFF',
  currency: 'USD',
}

export const DOWNLOADS = '1,247'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qE96bxEk2h1TvsuipAuyuT/ChatGPT_Image_3_sept_2026,_09_40_03_p.m..png'
